import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12 border-t border-gray-800" data-id="element-78">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79">
        <div className="flex flex-col items-center text-center space-y-6" data-id="element-80">
          {/* Logo */}
          <div className="bg-white p-3 rounded-lg" data-id="element-81">
            <img src="https://cdn.magicpatterns.com/uploads/6TXc6bvjECFRnTgAPwPHHs/SHIVAY_LOGO.png" alt="Shivaay Fashion" className="h-10 w-auto" data-id="element-82" />
          </div>

          {/* Description */}
          <p className="text-gray-400 max-w-2xl text-sm leading-relaxed" data-id="element-83">
            Shivaay Fashion (Shree Shivaay Creations) is a premier manufacturer
            and exporter of high-quality textiles, dedicated to weaving
            excellence since inception.
          </p>

          {/* Copyright */}
          <div className="border-t border-gray-800 pt-6 w-full" data-id="element-84">
            <p className="text-gray-500 text-sm" data-id="element-85">
              &copy; {new Date().getFullYear()} Shivaay Fashion. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}